import { useMemo } from 'react'
import { Platform, ToastAndroid } from 'react-native'
import { Toast, ToastDescription, useToast } from './ui/toast'

export default function useDefaultToast() {
  const toast = useToast()

  return useMemo(
    () => ({
      show: (message: string) => {
        if (Platform.OS === 'android') {
          ToastAndroid.showWithGravity(message, ToastAndroid.SHORT, ToastAndroid.TOP)
          return
        }
        toast.show({
          placement: 'top',
          duration: 3000,
          render: ({ id }) => {
            return (
              <Toast nativeID={`toast-${id}`} action="muted" variant="solid">
                <ToastDescription>{message}</ToastDescription>
              </Toast>
            )
          },
        })
      },
    }),
    [toast]
  )
}
